import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchDeptTree } from '@/api/system/dept/dept';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      options: [],
      rules: {
        deptName: [{
          required: true,
          message: '请输入部门名称',
          trigger: 'change'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 20 个字符',
          trigger: 'change'
        }],
        deptOrder: [{
          required: true,
          message: '请输入部门排序',
          trigger: 'change'
        }],
        deptDesc: [{
          max: 200,
          message: '最多可输入 200 个字符',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      childData: {
        upIdList: []
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      this.upDeptIds = [];

      if (this.$refs['dataForm'] !== undefined) {
        this.$refs['dataForm'].resetFields();
      }

      if (n) {
        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.options = [];
      this.loadDeptTree();
      this.loadData();
    },
    handleRemarkInput: function handleRemarkInput(val) {
      if (val.length > 99) {
        this.$message({
          message: '备注的最大长度不能超过100个字符',
          type: 'warning'
        });
      }

      this.$set(this.childData, 'deptDesc', val.slice(0, 100));
    },
    loadData: function loadData() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          deptId: this.keyValue
        };
        var upDeptIds = [];
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;

          _this.childData.upIdList.forEach(function (e) {
            upDeptIds.push(e.toString());
          });

          _this.childData.upIdList = upDeptIds;
        });
      } else {
        this.childData = {
          upIdList: []
        };
      }
    },
    loadDeptTree: function loadDeptTree() {
      var _this2 = this;

      var treeQuery = {};
      fetchDeptTree(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this3.childData.upDeptId = null;

          if (_this3.childData.upIdList.length > 0) {
            _this3.childData.upDeptId = _this3.childData.upIdList[_this3.childData.upIdList.length - 1];
          }

          delete _this3.childData.upIdList;

          if (_this3.keyValue > 0) {
            _this3.childData.deptId = _this3.keyValue;
            fetchUpdate(_this3.childData).then(function () {
              _this3.$emit('handCancle', true);

              _this3.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this3.childData).then(function () {
              _this3.keyValue = -1;

              _this3.$emit('handCancle', true);

              _this3.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};